import { defineComponent, computed } from 'vue';
export default defineComponent({
  name: 'InfoCard',
  props: ['data'],
  setup: function (props) {
    var pageConfig = computed(function () {
      return props.data.activityListPageConfig || {};
    });
    return {
      pageConfig: pageConfig
    };
  }
});